(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["broek-restock"] && !Shopify.designMode) return;
  try {
    (() => {
  const template = document.getElementById('broek-restock-content');
  const copy = document.getElementById('broek-restock-labels')?.dataset;
  if (!template || !copy) return;
  let opener;
  const keyboardButton = (element, label) => {
    if (!element || element.dataset.brKeyboard) return;
    element.dataset.brKeyboard = 'true';
    element.setAttribute('role', 'button');
    element.tabIndex = 0;
    if (label) element.setAttribute('aria-label', label);
    element.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        element.click();
      }
    });
  };
  const addLabel = (element, text, id) => {
    if (!element || element.dataset.brLabel) return;
    element.dataset.brLabel = 'true';
    element.id = id;
    element.setAttribute('aria-label', text);
    const label = document.createElement('label');
    label.className = 'br-restock-label';
    label.htmlFor = id;
    label.textContent = text;
    element.before(label);
  };
  const enhance = () => {
    const success = document.querySelector('.successSub');
    if (success && !success.dataset.brEnhanced) {
      success.dataset.brEnhanced = 'true';
      success.setAttribute('role', 'status');
      success.setAttribute('aria-live', 'polite');
      keyboardButton(success.querySelector('.successSub_close-box'), copy.close);
    }
    const trigger = document.querySelector('#sealapps-bis-widget .product-restore-email');
    keyboardButton(trigger);
    const modal = document.getElementById('email-me-frame');
    if (!modal || modal.dataset.brEnhanced) return;
    const body = modal.querySelector('.email-frame-body');
    const header = modal.querySelector('.email-frame-header');
    if (!body || !header) return;
    modal.dataset.brEnhanced = 'true';
    const content = template.content.cloneNode(true);
    header.after(content.querySelector('.br-restock-intro'));
    body.prepend(content.querySelector('.br-restock-product'));
    const title = modal.querySelector('.frame-title');
    title.id = 'broek-restock-title';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', title.id);
    const email = modal.querySelector('.buyer-email');
    email.type = 'email';
    email.autocomplete = 'email';
    email.inputMode = 'email';
    addLabel(email, copy.email, 'broek-restock-email');
    addLabel(modal.querySelector('.selected-unavailable-variant'), copy.variant, 'broek-restock-variant');
    const close = modal.querySelector('.close-box');
    const submit = modal.querySelector('.email-me-submitButton');
    keyboardButton(close, copy.close);
    keyboardButton(submit);
    email.addEventListener('keydown', event => {
      if (event.key === 'Enter') { event.preventDefault(); submit.click(); }
    });
    let wasOpen = false;
    const syncOpen = () => {
      const open = getComputedStyle(modal).display !== 'none';
      if (open === wasOpen) return;
      wasOpen = open;
      if (open) {
        if (!opener?.isConnected) opener = trigger || document.activeElement;
        requestAnimationFrame(() => email.focus({ preventScroll: true }));
      } else if (opener?.isConnected) {
        opener.focus({ preventScroll: true });
      }
    };
    new MutationObserver(syncOpen).observe(modal, { attributes: true, attributeFilter: ['style', 'class'] });
    modal.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close.click(); return; }
      if (event.key !== 'Tab') return;
      const items = [...modal.querySelectorAll('input, select, [tabindex="0"], a[href], button')].filter(el => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    syncOpen();
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('#sealapps-bis-widget .product-restore-email');
    if (trigger) opener = trigger;
  }, true);
  enhance();
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.id === 'email-me-frame' || node.matches?.('.product-restore-email, .successSub') || node.querySelector?.('#email-me-frame, .product-restore-email, .successSub'))))) enhance();
  }).observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["broek-v3-card"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.broekNativeCardGallery) return;
  window.broekNativeCardGallery = true;
  const states = new WeakMap();
  const selector = '[data-bv3-gallery]';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const loadNear = (state, index) => {
    for (let i = Math.max(1, index - 1); i <= Math.min(state.images.length - 1, index + 1); i++) {
      const img = state.images[i];
      if (!img.hasAttribute('src')) {
        const url = new URL(state.urls[i], location.origin);
        url.searchParams.set('width', String(Math.min(800, Math.max(320, Math.ceil(state.width * Math.min(devicePixelRatio || 1, 2) / 160) * 160))));
        img.src = url.href;
      }
    }
  };
  const prepare = (link, measuredWidth) => {
    if (states.has(link)) return states.get(link);
    const source = link.parentElement.querySelector('[data-bv3-gallery-images]');
    const original = link.querySelector('img');
    if (!source || !original) return null;
    let urls;
    try { urls = JSON.parse(source.textContent); } catch (_) { return null; }
    if (urls.length < 2) return null;
    const images = [original];
    const fragment = document.createDocumentFragment();
    for (let i = 1; i < urls.length; i++) {
      const img = new Image();
      img.alt = original.alt;
      img.width = Number(original.getAttribute('width')) || 600;
      img.height = Number(original.getAttribute('height')) || 800;
      img.decoding = 'async';
      img.fetchPriority = 'low';
      img.draggable = false;
      images.push(img);
      fragment.append(img);
    }
    const state = { link, width: measuredWidth || 320, urls, images, index: 0, frame: 0, suppress: 0 };
    states.set(link, state);
    original.draggable = false;
    link.append(fragment);
    link.classList.add('bv3-native-gallery');
    const dots = [...link.parentElement.querySelectorAll('.bv3-gallery-dot')];
    link.addEventListener('scroll', () => {
      if (state.frame) return;
      state.frame = requestAnimationFrame(() => {
        state.frame = 0;
        const index = Math.max(0, Math.min(images.length - 1, Math.round(link.scrollLeft / (link.clientWidth || 1))));
        state.index = index;
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        loadNear(state, index);
      });
    }, { passive: true });
    let start;
    link.addEventListener('touchstart', event => {
      start = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      loadNear(state, state.index);
    }, { passive: true });
    link.addEventListener('touchmove', event => {
      if (!start || event.touches.length !== 1) return;
      if (Math.abs(event.touches[0].clientX - start.x) > 8 || Math.abs(event.touches[0].clientY - start.y) > 8) state.suppress = Date.now() + 700;
    }, { passive: true });
    link.addEventListener('touchend', () => { start = null; }, { passive: true });
    link.addEventListener('touchcancel', () => { start = null; }, { passive: true });
    link.addEventListener('click', event => {
      if (state.suppress > Date.now()) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    link.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const index = Math.max(0, Math.min(images.length - 1, state.index + (event.key === 'ArrowRight' ? 1 : -1)));
      loadNear(state, index);
      link.scrollTo({ left: index * link.clientWidth, behavior: reduced.matches ? 'auto' : 'smooth' });
    });
    loadNear(state, 0);
    return state;
  };
  const observed = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    const visible = entries.filter(entry => entry.isIntersecting).map(entry => ({link:entry.target,width:entry.boundingClientRect.width}));
    visible.forEach(({link,width}) => { prepare(link,width); observer.unobserve(link); });
  }, { rootMargin: '180px' });
  const scan = root => {
    if (!(root instanceof Element || root === document)) return;
    const links = root.matches?.(selector) ? [root] : [...root.querySelectorAll(selector)];
    links.forEach(link => {
      if (observed.has(link)) return;
      observed.add(link);
      observer.observe(link);
    });
  };
  const start = () => {
    scan(document);
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan))).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["broek-v3-gallery-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('broek-gallery-controls')) {
  customElements.define('broek-gallery-controls', class extends HTMLElement {
    connectedCallback() {
      this.previous=this.querySelector('[data-gallery-prev]');
      this.next=this.querySelector('[data-gallery-next]');
      this.count=this.querySelector('[data-gallery-count]');
      this.media=this.closest('.product-detail__media');
      this.previous.onclick=()=>this.slider()?.slidePrev();
      this.next.onclick=()=>this.slider()?.slideNext();
      this.observer=new MutationObserver(()=>this.update());
      this.observer.observe(this.media.querySelector('media-gallery'),{subtree:true,attributes:true,attributeFilter:['class'],childList:true});
      this.update();
    }
    slider(){return this.media.querySelector('slide-with-thumbs')?.globalSlide;}
    update(){
      const slides=Array.from(this.media.querySelectorAll('.media-main-swiper .media-item'));
      const active=Math.max(0,slides.findIndex(s=>s.classList.contains('swiper-slide-active')));
      this.count.textContent=`${active+1} / ${slides.length}`;
      this.previous.disabled=active===0;
      this.next.disabled=active>=slides.length-1;
    }
    disconnectedCallback(){this.observer?.disconnect();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
